import { FC } from 'react'

/**
 * * Icon Component for: chevron-left
 */
type ChevronLeftOutlineIconProps = {
  size?: number
  color?: string
}
export const ChevronLeftOutlineIcon: FC<ChevronLeftOutlineIconProps> = ({
  size = '1rem',
  color = 'currentColor',
  ...rest
}) => {
  const iconAttributes = {
    width: size,
    height: size,
    stroke: color,
  }

  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 7 12" fill="none" {...rest} {...iconAttributes}>
      <path d="M6 11L1 6L6 1" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}
